module.exports = __webpack_public_path__ + "static/media/3Coins.de70859c.png";